<script>import { createEventDispatcher } from "svelte";
import { cn } from "../../utils/twClnm.js";
import CheckedIcon from "../../icons/CheckedIcon.svelte";
import UncheckedIcon from "../../icons/UncheckedIcon.svelte";
import ImageSelect from "../Filters/ImageSelect/ImageSelect.svelte";
export let value = "";
export let label = "";
export let labelClass = "";
export let wrapperClass = "";
export let checkboxType = "input";
export let src = "";
const dispatch = createEventDispatcher();
export let checked = false;
const onChange = () => {
  dispatch("change", {
    checked
  });
};
</script>

<label class={cn("tw-flex tw-flex-row tw-items-center", wrapperClass)}>
	<input
		type="checkbox"
		class="tw-absolute tw-left-0 tw-top-0 tw-hidden"
		{...$$restProps}
		id={value}
		value={value}
		on:change={onChange}
	/>

	{#if checkboxType === 'input'}
		<div class={checked ? 'tw-block tw-h-5 tw-w-5' : 'tw-hidden'}><CheckedIcon /></div>
		<div class={!checked ? 'tw-block tw-h-5 tw-w-5' : 'tw-hidden'}><UncheckedIcon /></div>
		<div class={cn('tw-select-none', labelClass)}>{label}</div>
	{/if}

	{#if checkboxType === 'image'}
		<ImageSelect src={src} selected={checked}></ImageSelect>
	{/if}
</label>
